var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11667 13.376L8.38333 9.90512L9.31667 8.91346L12.5833 5.44262C12.7056 5.31276 12.7667 5.14748 12.7667 4.94679C12.7667 4.7461 12.7056 4.58082 12.5833 4.45096C12.4611 4.32109 12.3056 4.25616 12.1167 4.25616C11.9278 4.25616 11.7722 4.32109 11.65 4.45096L8.38333 7.92179L7.45 8.91346L4.18333 12.3843C4.06111 12.5142 4 12.6794 4 12.8801C4 13.0808 4.06111 13.2461 4.18333 13.376C4.30556 13.5058 4.46111 13.5707 4.65 13.5707C4.83889 13.5707 4.99444 13.5058 5.11667 13.376Z",
    fill: "#154365"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 12.5417H8.66675V11.8334H12.0001V12.5417Z",
    fill: "#154365",
    stroke: "#154365",
    strokeWidth: 0.674214,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50249 8.0708C5.64058 8.21808 5.80363 8.29172 5.99164 8.29172C6.17965 8.29172 6.34296 8.21808 6.48158 8.0708C6.61966 7.92408 6.68871 7.75084 6.68871 7.55108V6.91624H7.30293C7.49094 6.91624 7.65425 6.8426 7.79287 6.69532C7.93096 6.54861 8 6.37537 8 6.17561C8 5.97584 7.93096 5.80232 7.79287 5.65504C7.65425 5.50832 7.49094 5.43497 7.30293 5.43497H6.68871V4.78236C6.68871 4.5826 6.61966 4.40907 6.48158 4.26179C6.34296 4.11508 6.17965 4.04172 5.99164 4.04172C5.80363 4.04172 5.64058 4.11508 5.50249 4.26179C5.36387 4.40907 5.29456 4.5826 5.29456 4.78236V5.43497H4.69707C4.50906 5.43497 4.34601 5.50832 4.20793 5.65504C4.06931 5.80232 4 5.97584 4 6.17561C4 6.37537 4.06931 6.54861 4.20793 6.69532C4.34601 6.8426 4.50906 6.91624 4.69707 6.91624H5.29456V7.55108C5.29456 7.75084 5.36387 7.92408 5.50249 8.0708Z",
    fill: "#154365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactor);
export default __webpack_public_path__ + "static/media/factor.3d0fadf55a47fac8588d93b2128a7b3f.svg";
export { ForwardRef as ReactComponent };